export const scrollTo = ({ ref = null, top = 0, topOffset = 0, behavior = 'smooth' }) => {
  const scrollPosition = ref ? ref.current.offsetTop - topOffset : top || 0
  const scrollSupported = 'scrollBehavior' in document.documentElement.style
  return scrollSupported
    ? window.scrollTo({ behavior, top: scrollPosition })
    : window.scrollTo(0, scrollPosition)
}
